<!-- place holder label for field alignment  -->
@if (lmColumnLayoutInfo?.nbrColumns > 1 || lmParagraphLayoutInfo?.hasVisibleLabels) {
  <label>&nbsp;</label>
}
<ng-container>
  @switch (displayType) {
    @case (layoutDisplayType.STAR) {
      <button
        [attr.id]="id"
        soho-button="favorite"
        (click)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        [attr.aria-describedby]="fieldDescriptionId"
        [attr.readOnly]="null"
        [state]="modelField.valueChanged | async"
        (focusout)="onFieldBlur($event)"
      ></button>
      <label
        soho-label
        [required]="required$ | async"
        [forCheckBox]="true"
        [attr.for]="id"
        lm-label
        [layoutField]="field"
        [personalize]="personalize"
        lm-text-style [textStyle]="field?.label?.textStyle"
        class="lm-checkbox-label"
        >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
    }
    @case (layoutDisplayType.BOX) {
      <input
        [ngClass]="fieldClassesString"
        type="checkbox"
        soho-checkbox
        [attr.id]="id"
        [attr.bindId]="bindId"
        [attr.readOnly]="null"
        [attr.disabled]="null"
        [attr.aria-describedby]="fieldDescriptionId"
        [(ngModel)]="modelField.value"
        (click)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (focusout)="onFieldBlur($event)"
        />
        <label
          soho-label
          [required]="required$ | async"
          [forCheckBox]="true"
          [attr.for]="id"
          lm-label
          [layoutField]="field"
          [personalize]="personalize"
          lm-text-style [textStyle]="field?.label?.textStyle"
          class="lm-checkbox-label"
          >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
        </label>
      }
      @case (layoutDisplayType.SWITCH) {
        <div class="switch"
          soho-tooltip content="{{triggerValueChange | async | booleanAsSwitchTooltip:modelField.value:false}}"
          [ngStyle]="{'display': 'inline-block'}"
          >
          <input
            [ngClass]="fieldClassesString"
            type="checkbox"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.readOnly]="null"
            [attr.disabled]="null"
            [attr.aria-describedby]="fieldDescriptionId"
            [(ngModel)]="modelField.value"
            (click)="onClickEvent($event)"
            (fieldEvent)="onFieldEvent($event)"
            (focusout)="onFieldBlur($event)"
            />
            <label
              soho-label
              [required]="required$ | async"
              [attr.for]="id"
              lm-label
              [layoutField] = "field"
              [personalize]="personalize"
              lm-text-style [textStyle]="field?.label?.textStyle"
              class="lm-checkbox-label"
              >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
            </label>
          </div>
        }
      }
    </ng-container>

    <ng-template #mouseOverTextTemplate>
      @if (layoutObject.mouseOverText) {
        <lm-mouse-over-text
          [beforeShowTooltip]="displayMouseOverText"
        ></lm-mouse-over-text>
      }
    </ng-template>

    <span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>